import React, { useState, useEffect } from 'react';
import { ArrowLeft } from 'lucide-react';
import downArrow from "../assets/downArrow.png";
import affProg from "../assets/affProg.png";
import axios from 'axios';
import api from '../utils/api';
import AF1 from "../assets/AF1.png";
import AF2 from "../assets/AF2.png";
import AF3 from "../assets/AF3.png";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function SignedInAffiliate() {
  const [copied, setCopied] = useState(false);
  const [affiliateCode, setAffiliateCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [orderCount, setOrderCount] = useState(0);
  const [creditEarned, setCreditEarned] = useState(0);
  const [requestLoading, setRequestLoading] = useState(false);

  const authToken = localStorage.getItem('authToken');

  const [formData, setFormData] = useState({
    facebook: "",
    instagram: "",
    tiktok: "",
    youtube: "",
    twitch: "",
    twitter: "",
  });


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Fetch user ID
      const userResponse = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/users/me`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      const userId = userResponse.data._id;

      // Send the form data to the backend API
      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/generate-affiliate-code/request-graphic-video`,
        {
          userId,
          socialMediaLinks: formData,
        }
      );

      // Display success toast
      toast.success("Request sent successfully!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

      togglePopup(); // Close the popup
    } catch (error) {
      console.error("Error submitting request:", error);

      // Display error toast
      toast.error("Failed to send the request. Please try again.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };


  const [isPopupVisible, setIsPopupVisible] = useState(false);

  const togglePopup = () => {
    setIsPopupVisible((prev) => !prev);
  };

  const handleCopy = () => {
    const universalUrl = `https://futcoinspot.com/?referralCode=${affiliateCode}`;

    navigator.clipboard.writeText(universalUrl)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      })
      .catch((error) => {
        console.error("Failed to copy URL to clipboard:", error);
      });
  };


  const fetchAffiliateDetails = async () => {
    setLoading(true);
    try {
      const userResponse = await api.get(`${process.env.REACT_APP_API_BASE_URL}/users/me`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      const userId = userResponse.data._id;

      const affiliateResponse = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/generate-affiliate-code/affiliate/details/${userId}`);

      if (affiliateResponse.data) {
        setAffiliateCode(affiliateResponse.data.affiliateCode || "");
        setOrderCount(affiliateResponse.data.orderCount || 0);
        setCreditEarned(affiliateResponse.data.creditEarned || 0);
      }
    } catch (error) {
      console.error('Error fetching affiliate details:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAffiliateDetails();
  }, []);

  const handleGenerateCode = async () => {
    if (affiliateCode) {
      handleCopy(); // If the code already exists, copy it directly
      return;
    }

    setLoading(true);
    try {
      const userResponse = await api.get(`${process.env.REACT_APP_API_BASE_URL}/users/me`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      const userId = userResponse.data._id;

      const affiliateResponse = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/generate-affiliate-code`, {
        userId,
      });

      const generatedCode = affiliateResponse.data.affiliateCode;

      setAffiliateCode(generatedCode);

      // Store the referral code in localStorage
      localStorage.setItem("referralCode", generatedCode);
    } catch (error) {
      console.error('Error generating affiliate code:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleRequestGraphics = async () => {
    setRequestLoading(true);
    try {
      const userResponse = await api.get(`${process.env.REACT_APP_API_BASE_URL}/users/me`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      const userId = userResponse.data._id;

      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/generate-affiliate-code/request-graphic-video`, {
        userId,
      });

      alert('Request for FCS Graphics sent successfully!');
    } catch (error) {
      console.error('Error requesting graphics:', error);
      alert('Failed to send request. Please try again.');
    } finally {
      setRequestLoading(false);
    }
  };

  return (
    <div className="min-h-screen lg: bg-[#191919]  bg-[#191919]  p-6 font-inter">
      <ToastContainer />
      <button className="flex items-center text-white gap-2 mb-12">
        <div className="flex items-center justify-center w-8 h-8 rounded-full border border-white/20">
          <ArrowLeft className="w-4 h-4" />
        </div>
        <a href='/'>Back</a>
      </button>

      <div className="max-w-5xl mx-auto space-y-8">
        <h1 className="text-4xl md:text-6xl font-monument font-extrabold text-primary text-center tracking-wider">
          AFFILIATE PROGRAM
        </h1>

        <div className="flex flex-col items-center gap-4">
          <button className="bg-primary text-black px-8 py-3 rounded-full font-medium flex items-center gap-2">
            <span className="text-purple-600 text-xl">🎮</span>
            Lets Earn
          </button>
          <img src={downArrow} alt="Arrow Down" className="h-8" />
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          <div className="space-y-6">
            <div className="space-y-4 border rounded-lg border-white p-4">
              <div className="bg-primary text-black p-4 rounded-lg">
                Welcome to the Futcoinspot Affiliate Program 🎉
              </div>

              <h2 className="text-primary text-xl font-medium">
                How can you boost your earnings? 🚀
              </h2>

              <div className="flex gap-4 items-start">
                <div className="w-8 h-8 flex-shrink-0">
                  <img
                    src={AF1}
                    alt="Robot with coin"
                    className="w-full h-full"
                  />
                </div>
                <p className="text-primary text-sm">
                  Refer your exclusive code among friends and family
                </p>
              </div>

              <div className="flex gap-4 items-start">
                <div className="w-8 h-8 flex-shrink-0">
                  <img
                    src={AF3}
                    alt="Robot with coin"
                    className="w-full h-full mt-4"
                  />
                </div>
                <p className="text-primary text-sm">
                  Share your exclusive FIFA discount code in your social posts—just make sure our site takes center stage in your videos so everyone knows where to grab their deal!
                </p>
              </div>
            </div>

            <div className="bg-primary text-black rounded-lg p-4 border border-white">
              <div className="flex items-center gap-2 ">
                <span className="text-primary">💰</span>
                <p className="text-black text-sm font-medium">
                  Earn up to 5% commission for every order placed using your discount code
                </p>
              </div>
            </div>

            <div className="space-y-4">
              <div className="bg-zinc-900 rounded-lg p-4 border border-white">
                <div className="text-primary text-4xl font-bold">{orderCount}</div>
                <div className="text-primary text-sm mt-1">ORDERS PLACED</div>
              </div>

              <div className="bg-zinc-900 rounded-lg p-4 border border-white">
                <div className="text-primary text-4xl font-bold">${creditEarned}</div>
                <div className="text-primary text-sm mt-1">COMMISSION EARNED</div>
              </div>
            </div>
          </div>

          <div className="space-y-6">
            <div className="bg-primary rounded-lg p-16">
              <h2 className="text-2xl font-bold text-center mb-8">
                Referral Link
              </h2>
              <p className="text-center mb-4">
                Ask your friends to order through your referral link to earn commission!              </p>
              <div className="hidden border-2 border-dashed border-black p-4 text-center text-2xl font-bold mb-4">
                {affiliateCode ? affiliateCode : "------------"}
              </div>
              <button
                onClick={affiliateCode ? handleCopy : handleGenerateCode}
                className="w-full bg-black text-white p-8 rounded-lg font-inter text-xl mb-4"
                disabled={loading}
              >
                {loading ? "Generating..." : affiliateCode ? (copied ? "Link Copied!" : "Copy Refferal Link") : "Generate Refferal Link"}
              </button>
            </div>

            <div className="bg-primary rounded-lg p-6">
              <p className="text-center mb-4">
                Want FCS Graphics for your video? Request below.
              </p>
              <button
                onClick={togglePopup}
                className="w-full bg-black text-white p-8 rounded-lg font-inter text-xl mb-4"
              >
                Request
              </button>

              {isPopupVisible && (
                <div
                  className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
                  onClick={(e) => {
                    if (e.target === e.currentTarget) {
                      togglePopup(); // Close popup when clicking outside
                    }
                  }}
                >
                  <form
                    onSubmit={handleSubmit}
                    className="relative w-full max-w-md bg-primary p-6 rounded-lg font-inter"
                    onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
                  >
                    {/* Close Button */}
                    <button
                      type="button"
                      onClick={togglePopup} // Close popup when clicked
                      className="absolute top-2 right-2 bg-black text-primary p-2 rounded-full hover:bg-gray-800"
                    >
                      ✕
                    </button>

                    <h1 className="mb-6 text-3xl font-bold text-black">Social Media Links</h1>
                    <div className="space-y-2">
                      {/* Facebook */}
                      <div className="flex items-center gap-3">
                        <input type="checkbox" className="h-4 w-4 rounded border-black" />
                        <div className="flex items-center gap-2">
                          <i className="fab fa-facebook-f text-black text-xl"></i>
                          <span className="text-lg text-black">Facebook</span>
                        </div>
                      </div>
                      <input
                        type="text"
                        name="facebook"
                        value={formData.facebook}
                        onChange={handleInputChange}
                        placeholder="Facebook URL"
                        className="w-full rounded border border-black bg-primary p-2 text-black text-sm"
                      />

                      {/* Instagram */}
                      <div className="flex items-center gap-3">
                        <input type="checkbox" className="h-4 w-4 rounded border-black" />
                        <div className="flex items-center gap-2">
                          <i className="fab fa-instagram text-black text-xl"></i>
                          <span className="text-lg text-black">Instagram</span>
                        </div>
                      </div>
                      <input
                        type="text"
                        name="instagram"
                        value={formData.instagram}
                        onChange={handleInputChange}
                        placeholder="Instagram URL"
                        className="w-full rounded border border-black bg-primary p-2 text-black text-sm"
                      />

                      {/* TikTok */}
                      <div className="flex items-center gap-3">
                        <input type="checkbox" className="h-4 w-4 rounded border-black" />
                        <div className="flex items-center gap-2">
                          <i className="fab fa-tiktok text-black text-xl"></i>
                          <span className="text-lg text-black">TikTok</span>
                        </div>
                      </div>
                      <input
                        type="text"
                        name="tiktok"
                        value={formData.tiktok}
                        onChange={handleInputChange}
                        placeholder="TikTok URL"
                        className="w-full rounded border border-black bg-primary p-2 text-black text-sm"
                      />

                      {/* YouTube */}
                      <div className="flex items-center gap-3">
                        <input type="checkbox" className="h-4 w-4 rounded border-black" />
                        <div className="flex items-center gap-2">
                          <i className="fab fa-youtube text-black text-xl"></i>
                          <span className="text-lg text-black">YouTube</span>
                        </div>
                      </div>
                      <input
                        type="text"
                        name="youtube"
                        value={formData.youtube}
                        onChange={handleInputChange}
                        placeholder="YouTube URL"
                        className="w-full rounded border border-black bg-primary p-2 text-black text-sm"
                      />

                      {/* Twitch */}
                      <div className="flex items-center gap-3">
                        <input type="checkbox" className="h-4 w-4 rounded border-black" />
                        <div className="flex items-center gap-2">
                          <i className="fab fa-twitch text-black text-xl"></i>
                          <span className="text-lg text-black">Twitch</span>
                        </div>
                      </div>
                      <input
                        type="text"
                        name="twitch"
                        value={formData.twitch}
                        onChange={handleInputChange}
                        placeholder="Twitch URL"
                        className="w-full rounded border border-black bg-primary p-2 text-black text-sm"
                      />

                      {/* Twitter */}
                      <div className="flex items-center gap-3">
                        <input type="checkbox" className="h-4 w-4 rounded border-black" />
                        <div className="flex items-center gap-2">
                          <i className="fab fa-twitter text-black text-xl"></i>
                          <span className="text-lg text-black">Twitter</span>
                        </div>
                      </div>
                      <input
                        type="text"
                        name="twitter"
                        value={formData.twitter}
                        onChange={handleInputChange}
                        placeholder="Twitter URL"
                        className="w-full rounded border border-black bg-primary p-2 text-black text-sm"
                      />
                    </div>

                    <button
                      type="submit"
                      className="mt-6 w-full rounded-md bg-black py-2 text-lg font-medium text-primary"
                    >
                      Submit
                    </button>
                  </form>
                </div>
              )}

            </div>
          </div>
        </div>

        <div className="relative">
          <img src={affProg} alt="Affiliate Program Banner" className="w-full h-auto" />
        </div>
      </div>
    </div>
  );
}
